import $ from "jquery";
import { ADMIN_ENDPOINT } from "../api";

export function failureToError(failureHandler) {
	return (jqXHR) => {
		const responseJSON = jqXHR.responseJSON;
		const error = {
			code: responseJSON?.code || "fetch_error",
			message: responseJSON?.message || "An unexpected error occurred.",
		};
		failureHandler([error]);
	};
}

export function failureToErrorOnUpdate(failureHandler) {
	return (jqXHR) => {
		const responseJSON = jqXHR.responseJSON;
		const errors = responseJSON.map((error) => ({
			code: error.code || "unexpected_error",
			message: error.message || "An unexpected error occurred.",
		}));
		failureHandler(errors);
	};
}

export function getProfileData(id, namespace, onSuccess, onError) {
	$.ajax({
		url: `${ADMIN_ENDPOINT}/${namespace}/${id}`,
		type: "GET",
		success: onSuccess,
		error: failureToError(onError),
	});
}

export function updateProfileData(id, data, namespace, onSuccess, onError) {
	$.ajax({
		url: `${ADMIN_ENDPOINT}/${namespace}/${id}`,
		data: JSON.stringify(data),
		type: "POST",
		dataType: "json",
		contentType: "application/json",
		success: onSuccess,
		error: failureToErrorOnUpdate(onError),
	});
}

export function updateBioData(id, data, namespace, onSuccess, onError) {
	$.ajax({
		url: `${ADMIN_ENDPOINT}/${namespace}/${id}/bio`,
		data: JSON.stringify(data),
		type: "POST",
		dataType: "json",
		contentType: "application/json",
		success: onSuccess,
		error: failureToErrorOnUpdate(onError),
	});
}

export function syncProfileData(id, namespace, onSuccess, onError) {
	$.ajax({
		url: `${ADMIN_ENDPOINT}/${namespace}/${id}/sync`,
		type: "POST",
		dataType: "json",
		contentType: "application/json",
		success: onSuccess,
		error: failureToError(onError),
	});
}
